// extracted by mini-css-extract-plugin
export var dropdown = "_u6-0";
export var imageWrapper = "_u6-3";
export var itemNameContainer = "_u6-1";
export var productImage = "_u6-2";
export var spinnerWrapper = "_u6-4";